import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LotteryAnswers } from '@/components/Lottery/LotteryFaq/LotteryAnswers/LotteryAnswers';
import { LotteryFaqBanner } from '@/components/Lottery/LotteryFaq/LotteryFaqBanner/LotteryFaqBanner';
import { H1, TextMain } from '@/components/Typography/Typography';

import css from './styles.module.scss';

const LotteryFaq: FC = () => {
  const { t } = useTranslation();

  const description =
    "It's your chance to test your luck and win valuable prizes! By taking part in events and completing contracts, you earn Silver, Gold, and Diamond tickets that enter weekly and seasonal draws for T-Gem, dice and tickets.";

  return (
    <div className={css.lotteryFaq}>
      <LotteryFaqBanner />
      <H1 weight="bold" className="mt-4">
        {t('What is Ticket Draw?')}
      </H1>
      <TextMain className="!leading-[150%] mt-4">{t(description)}</TextMain>
      <LotteryAnswers />
    </div>
  );
};

export { LotteryFaq };
